import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

// NOTE: FETCH USER PROPERTIES
export const fetchUserProperties = createAsyncThunk(
  "property/fetchUserProperties",
  async (arg) => {
    const query = generateQueryParams(arg);
    const response = await api.get(`/property/user?${query}`);
    return response.data;
  }
);

// NOTE: FETCH SINGLE USER PROPERTIES
export const fetchSingleUserProperties = createAsyncThunk(
  "property/fetchUserProperties",
  async ({ offset, limit }) => {
    const response = await api.get(`/property/user`)
    return response.data;
  }
);

// NOTE: CREATE PROPERTY
export const createProperty = createAsyncThunk(
  "property/createProperty",
  async (propertyData) => {
    const response = await api.post("/property", propertyData);
    return response.data;
  }
);

// NOTE: EDIT PROPERTY
export const editProperty = createAsyncThunk(
  "property/editProperty",
  async ({propertyData, propertyId}) => {
    const response = await api.put(`/property/user/${propertyId}`, propertyData);
    return response.data;
  }
);

// NOTE: DELETE PROPERTY
export const deleteProperty = createAsyncThunk(
  "delete/property/user/:propertyId",
  async ({propertyId}) => {
    // console.log('thunk', propertyId);
    const response = await api.delete(`/property/user/${propertyId}`);
    return response.data;
  }
);

// NOTE: FETCH PROPERTY BY PROPERTY ID
export const getSingleProperty = createAsyncThunk(
  "property/:propertyId",
  async ({ propertyId }) => {
    const response = await api.get(`/property/${propertyId}`);
    return response.data;
  }
);

// NOTE: FETCH UNITS BY PROPERTY ID
export const fetchUnitsByPropertyId = createAsyncThunk(
  "property/:propertyId/units",
  async ({ propertyId, offset, limit }) => {
    const response = await api.get(`/property/user/${propertyId}/units?limit=${limit}&offset=${offset}`);
    return response.data;
  }
);

// NOTE: EDIT UNIT
export const editUnit = createAsyncThunk(
  "property/unit/:unitId",
  async ({unitData, unitId}) => {
    const response = await api.put(`/property/unit/${unitId}`, unitData);
    return response.data;
  }
);

// NOTE: EDIT OCCUPIED UNIT
export const editOccupiedUnit = createAsyncThunk(
  "property/unit/occupied/:unitId",
  async ({ unitId, occupiedData }) => {
    const response = await api.post(`/property/unit/occupied/${unitId}`, occupiedData);
    return response.data;
  }
);

// NOTE: FETCH UNIT DATA , TENANT DATA
export const fetchUnitData = createAsyncThunk(
  "property/unit/:unitId",
  async ({ unitId }) => {
    const response = await api.get(`/property/unit/${unitId}`);
    return response.data;
  }
);

// NOTE: EDIT TENANT DATA
export const editTenantData = createAsyncThunk(
  "property/unit/:unitId/tenant/:tenantId",
  async ({ propertyId, unitId, tenantId, data }) => {
    const response = await api.put(`property/${propertyId}/unit/${unitId}/tenant/${tenantId}`, data);
    return response.data;
  }
);

// NOTE: ADD TENANT DATA
export const addTenantData = createAsyncThunk(
  "property/:propertyId/unit/:unitId/tenant",
  async ({ propertyId, unitId, data }) => {
    const response = await api.post(`property/${propertyId}/unit/${unitId}/tenant`, data);
    return response.data;
  }
);

// NOTE: DELETE TENANT 
export const deleteTenant = createAsyncThunk(
  "property/unit/tenant/delete",
  async ({ propertyId, unitId, tenantId }) => {
    const response = await api.delete(`property/${propertyId}/unit/${unitId}/tenant/${tenantId}`);
    return response.data;
  }
);

export const deleteTenantWithReview = createAsyncThunk(
    "property/unit/tenant/delete",
    async ({ propertyId, unitId, tenantId, review }) => {
        const response = await api.post(`property/with-review/${propertyId}/unit/${unitId}/tenant/${tenantId}`,
            { review }
            );
        return response.data;
    }
);

export const fetchPrevRatings = createAsyncThunk(
    "property/unit/tenant/get",
    async ( { email , phoneNumber }) => {
        console.log(phoneNumber)
        const phoneClean = String(phoneNumber).trim();
        const response = await api.post(`property/reviews/previous/${email}`,    { phoneNumber }
        );
        return response.data;
    }
);

